import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import { MatInputModule } from '@angular/material/input';
import { VoiceMacroData, VoiceMacroDialog } from './voice-macro-dialog.component';
import { FormsModule } from '@angular/forms';

/** New Voice Macro Dialog */
@Component({
    selector: 'import-voice-macro-new-dialog',
    imports: [
        MatDialogModule,
        MatButtonModule,
				MatInputModule,
				FormsModule
    ],
    templateUrl: './import-voice-macro-dialog.component.html',
    styleUrl: './import-voice-macro-dialog.component.scss'
})
export class ImportVoiceMacroDialog implements OnInit {

	data: string ='';

	constructor(private dialogRef:MatDialogRef<boolean, ImportVoiceMacroDialog>) {
	}

	ngOnInit():void {
		this.dialogRef.updateSize('600px');
	}

	get voiceMacros(): VoiceMacroData[] {
		return this.parseData();
	}

	private parseData(): VoiceMacroData[] {
		const macros: VoiceMacroData[] = [];
		const lines = this.data.split(/[\n\r]/);
		for(let line of lines) {
			if(line.trim().length) {
				const values = line.split(/\t/);
				macros.push({
					section: values[0],
					phrase: values[1],
					substitution: values[2]
				});
			}
		}
		return macros;
	}
}
